var _defs, _polygon, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28.9 28.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #8a8a8d;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "28.9 0 .3 28.7 28.9 28.7 28.9 0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m18.42,18.06v.7c.15-.01.32-.02.51-.02v-.68c0-.29.08-.56.2-.8h-.56c-.09.25-.15.52-.15.8Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m22.31,17.26c.12.24.2.51.2.8v.68c.19,0,.36,0,.51.02v-.7c0-.28-.06-.55-.15-.8h-.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m20.72,15.76c-.99,0-1.82.63-2.15,1.5h.56c.29-.58.89-.99,1.59-.99s1.3.4,1.59.99h.56c-.33-.87-1.16-1.5-2.15-1.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 16.98,
    y: 18.59,
    width: 7.47,
    height: 5.34,
    rx: 0.53,
    ry: 0.53
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.e3915669581cb4d4d3f45965fb89930c.svg";
export { ForwardRef as ReactComponent };